
import axios from 'axios';

const fetch = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://api-device-bsc.deeper.network/' : 'http://localhost:7001',
  timeout: 30000
})


export default fetch

